import styled from 'styled-components';
import * as palette from '@mlc/mlc-palette';

export const DropdownContentItemPointer = styled.div`
	background-color: inherit;

	&::after {
		background-color: inherit;
		content: '';
		height: 15px;
		left: 85%;
		position: absolute;
		top: -8px;
		transform: rotate(45deg);
		width: 15px;
	}
`;

export const DropdownContentItem = styled.li`
	list-style-type: none;
	margin: 0;

	&:hover,
	&:hover > a,
	&:focus,
	&:focus > a,
	&:focus-within,
	&:focus-within > a {
		background-color: ${palette.mlcAqua};
		color: ${palette.mlcWhite};
		cursor: pointer;
		text-decoration: underline;
	}
`;

export const DropdownContentLink = styled.a`
	align-items: center;
	background-color: ${palette.mlcKoala};
	color: ${palette.mlcText};
	display: flex;
	flex-direction: row;
	padding: 0 0 0 10px;
	text-decoration: none;
	width: 220px;
`;

export const DropdownContentText = styled.p`
	align-items: center;
	background-color: inherit;
	color: inherit;
	display: flex;
	height: 50px;
	margin: 0;
	padding: 0 10px;
	text-decoration: inherit;
`;
